import { IconUserCog, IconSearch, IconClipboardList, IconCoins, IconInfoSquareRounded } from '@tabler/icons-react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { NavigationLink, NavigationLinksContext } from '#features/navigation'
import { IStaffConfirmationStatus, StaffContext, staffMeQueryOptions } from '#entities/staff'

interface StaffDataProviderProps {
  children?: React.ReactNode
}

export default function StaffDataProvider({ children }: StaffDataProviderProps) {
  const staffMeQuery = useSuspenseQuery(staffMeQueryOptions)
  const currentStaff = staffMeQuery.data

  const staffNavigationLinks = useMemo<NavigationLink[]>(() => {
    if (!currentStaff) return []

    const staffNavigationLinks: NavigationLink[] = [
      {
        icon: <IconInfoSquareRounded />,
        to: '/staff/info',
        displayName: 'Информация',
      },
      {
        icon: <IconUserCog />,
        to: '/staff/profile',
        displayName: 'Профиль',
      },
    ]

    if (currentStaff.confirmationStatus === IStaffConfirmationStatus.ProfileConfirmed) {
      staffNavigationLinks.push(
        {
          icon: <IconCoins />,
          to: '/staff/balance',
          displayName: 'Баланс',
        },
        {
          icon: <IconClipboardList />,
          to: '/staff/orders',
          displayName: 'Заказы',
        },
        {
          icon: <IconSearch />,
          to: '/staff/take-order',
          displayName: 'Взять заказ',
        }
      )
    }

    return staffNavigationLinks
  }, [currentStaff])

  return (
    <NavigationLinksContext.Provider value={staffNavigationLinks}>
      <StaffContext.Provider value={currentStaff}>{children}</StaffContext.Provider>{' '}
    </NavigationLinksContext.Provider>
  )
}
